import { DataService } from "./DataService";

export const DataProject = {
  title: "Les derniers projets réalisés",
  subTitle: "Nos Réalisations",
  dataService: DataService,

  // table projects
  // items: [
  //   {
  //     id: 1,
  //     title: "Travaux d’électricité",
  //     desc: "Travaux d’électricité Bâtiment 03 pièces au compte de la société PWA Energy Solution.",
  //     img: "assets/images/portfolio/portfolio-1.png",
  //     type: 1,
  //     gallery: [
  //       {
  //         id: 1,
  //         img: "assets/images/portfolio/portfolio-1.png",
  //       },
  //       {
  //         id: 2,
  //         img: "assets/images/portfolio/portfolio-2.png",
  //       },
  //       {
  //         id: 3,
  //         img: "assets/images/portfolio/portfolio-3.png",
  //       },
  //     ],
  //     client: "PWA Energy Solution",
  //     date: "05 May 2023",
  //     delay: "02 jours",
  //   },
  //   {
  //     id: 2,
  //     title: "Fourniture d’un coffret automatique",
  //     desc: "Fourniture d’un coffret automatique, Bonbonne à vessie, cable électrique 200 m pour installation d’une pompe de forage à Perseus Mining Yaouré",
  //     img: "assets/images/portfolio/portfolio-2.png",
  //     type: 1,
  //     gallery: [
  //       {
  //         id: 1,
  //         img: "assets/images/projects-details/projects-details.jpg",
  //       },
  //       {
  //         id: 2,
  //         img: "assets/images/portfolio/portfolio-2.png",
  //       },
  //       {
  //         id: 3,
  //         img: "assets/images/portfolio/portfolio-3.png",
  //       },
  //     ],
  //     client: "Perseus Mining Yaouré",
  //     date: "05 May 2023",
  //     delay: "3 mois",
  //   },
  //   {
  //     id: 3,
  //     title: "Projet d’électrification",
  //     desc: "Projet d’électrification du village N’GUETTIAKRO dans le partement de BONDOUKOU (Projet CI-Energies) ",
  //     img: "assets/images/portfolio/portfolio-3.png",
  //     type: 2,
  //     gallery: [
  //       {
  //         id: 1,
  //         img: "assets/images/portfolio/portfolio-1.png",
  //       },
  //       {
  //         id: 2,
  //         img: "assets/images/portfolio/portfolio-2.png",
  //       },
  //       {
  //         id: 3,
  //         img: "assets/images/portfolio/portfolio-3.png",
  //       },
  //     ],
  //     client: "Projet CI-Energies",
  //     date: "05 May 2023",
  //     delay: "1 mois",
  //   },
  //   {
  //     id: 4,
  //     title: "Projet de construction",
  //     desc: "Projet de construction de AFRICAN SAND LODGE HOTEL à cqueville. Lot: Courant fort et courant faible (Bâtiment)",
  //     img: "assets/images/portfolio/portfolio-4.png",
  //     type: 2,
  //     gallery: [
  //       {
  //         id: 1,
  //         img: "assets/images/portfolio/portfolio-1.png",
  //       },
  //       {
  //         id: 2,
  //         img: "assets/images/portfolio/portfolio-2.png",
  //       },
  //       {
  //         id: 3,
  //         img: "assets/images/portfolio/portfolio-3.png",
  //       },
  //     ],
  //     client: "AFRICAN SAND LODGE HOTEL",
  //     date: "05 May 2023",
  //     delay: "6 mois",
  //   },
  //   {
  //     id: 5,
  //     title: "Test d’équipements électriques",
  //     desc: " Contrat de test d’équipements électriques (Ampliance test) à rseus Mining Yaouré",
  //     img: "assets/images/portfolio/portfolio-5.png",
  //     type: 3,
  //     gallery: [
  //       {
  //         id: 1,
  //         img: "assets/images/portfolio/portfolio-1.png",
  //       },
  //       {
  //         id: 2,
  //         img: "assets/images/portfolio/portfolio-2.png",
  //       },
  //       {
  //         id: 3,
  //         img: "assets/images/portfolio/portfolio-3.png",
  //       },
  //     ],
  //     client: "Perseus Mining Yaouré",
  //     date: "05 May 2023",
  //     delay: "12 mois",
  //   },
  //   {
  //     id: 6,
  //     title: "Projet de déplacement",
  //     desc: " Projet de déplacement d’une ligne Haute Tension (11 KV) au TSF à Perseus Mining Yaouré",
  //     img: "assets/images/portfolio/portfolio-1.png",
  //     type: 3,
  //     gallery: [
  //       {
  //         id: 1,
  //         img: "assets/images/portfolio/portfolio-1.png",
  //       },
  //       {
  //         id: 2,
  //         img: "assets/images/portfolio/portfolio-2.png",
  //       },
  //       {
  //         id: 3,
  //         img: "assets/images/portfolio/portfolio-3.png",
  //       },
  //     ],
  //     client: "Perseus Mining Yaouré ",
  //     date: "05 May 2023",
  //     delay: "3 jours",
  //   },
  //   {
  //     id: 7,
  //     title: "Revision Générale",
  //     desc: " Revision Générale du Transformateur 630 KVA de marque NEXANS pour MONDI Abidjan SA ",
  //     img: "assets/images/portfolio/portfolio-2.png",
  //     type: 4,
  //     gallery: [
  //       {
  //         id: 1,
  //         img: "assets/images/portfolio/portfolio-1.png",
  //       },
  //       {
  //         id: 2,
  //         img: "assets/images/portfolio/portfolio-2.png",
  //       },
  //       {
  //         id: 3,
  //         img: "assets/images/portfolio/portfolio-3.png",
  //       },
  //     ],
  //     client: "MONDI Abidjan SA",
  //     date: "05 May 2023",
  //     delay: "7 jours",
  //   },
  //   {
  //     id: 8,
  //     title: "Fourniture et raccordement",
  //     desc: "Projet Banque Mondiale-Ministère de la santé de Cote d’Ivoire: Fourniture et raccordement de deux (02) Groupes Electrogènes de 160 KVA, 02 Régulateurs de tension de 180 KVA et 250 KVA et installation des unites de production d’oxygiène aux CHR d’Aboisso et Korogho au compte de SICOS Sarl  ",
  //     img: "assets/images/portfolio/portfolio-3.png",
  //     type: 4,
  //     gallery: [
  //       {
  //         id: 1,
  //         img: "assets/images/portfolio/portfolio-1.png",
  //       },
  //       {
  //         id: 2,
  //         img: "assets/images/portfolio/portfolio-2.png",
  //       },
  //       {
  //         id: 3,
  //         img: "assets/images/portfolio/portfolio-3.png",
  //       },
  //     ],
  //     client: "SICOS Sarl",
  //     date: "05 May 2023",
  //     delay: "5 mois",
  //   },
  //   {
  //     id: 9,
  //     title: "Compagne de mesure",
  //     desc: "Compagne de mesure de terre à PERSEUS MINING YAOURE SA",
  //     img: "assets/images/portfolio/portfolio-4.png",
  //     type: 5,
  //     gallery: [
  //       {
  //         id: 1,
  //         img: "assets/images/portfolio/portfolio-1.png",
  //       },
  //       {
  //         id: 2,
  //         img: "assets/images/portfolio/portfolio-2.png",
  //       },
  //       {
  //         id: 3,
  //         img: "assets/images/portfolio/portfolio-3.png",
  //       },
  //     ],
  //     client: "PERSEUS MINING YAOURE SA",
  //     date: "05 May 2023",
  //     delay: "3 jours",
  //   },
  //   {
  //     id: 10,
  //     title: "Remplacement d’un Transformateur H61",
  //     desc: " Projet Banque Mondiale-Ministère de la santé de Cote d’Ivoire Remplacement d’un Transformateur H61 par un poste préfabriqué de 630 KVA-15 KV /400 V et installation Aéro-souterraine 33 KV au CHR d’Agboville au compte de EGEET-CI ",
  //     img: "assets/images/portfolio/portfolio-5.png",
  //     type: 5,
  //     gallery: [
  //       {
  //         id: 1,
  //         img: "assets/images/portfolio/portfolio-1.png",
  //       },
  //       {
  //         id: 2,
  //         img: "assets/images/portfolio/portfolio-2.png",
  //       },
  //       {
  //         id: 3,
  //         img: "assets/images/portfolio/portfolio-3.png",
  //       },
  //     ],
  //     client: "EGEET-CI",
  //     date: "05 May 2023",
  //     delay: "14 jours",
  //   },
  //   {
  //     id: 11,
  //     title: "Installation et télégestion",
  //     desc: " Installation et télégestion d’un Groupe Electrogène de 800 KVA au compte de PERSEUS MINING YAOURE SA",
  //     img: "assets/images/portfolio/portfolio-5.png",
  //     type: 5,
  //     gallery: [
  //       {
  //         id: 1,
  //         img: "assets/images/portfolio/portfolio-1.png",
  //       },
  //       {
  //         id: 2,
  //         img: "assets/images/portfolio/portfolio-2.png",
  //       },
  //       {
  //         id: 3,
  //         img: "assets/images/portfolio/portfolio-3.png",
  //       },
  //     ],
  //     client: " PERSEUS MINING YAOURE SA",
  //     date: "05 May 2023",
  //     delay: "7 jours",
  //   },
  //   {
  //     id: 12,
  //     title: "Tests de fonctionnement",
  //     desc: "Tests de fonctionnement de 19 Relais ABB et Schneider Electric des Transformateurs et Cellules du Power Station de PERSEUS MINING YAOURE SA ",
  //     img: "assets/images/portfolio/portfolio-5.png",
  //     type: 5,
  //     gallery: [
  //       {
  //         id: 1,
  //         img: "assets/images/portfolio/portfolio-1.png",
  //       },
  //       {
  //         id: 2,
  //         img: "assets/images/portfolio/portfolio-2.png",
  //       },
  //       {
  //         id: 3,
  //         img: "assets/images/portfolio/portfolio-3.png",
  //       },
  //     ],
  //     client: "PERSEUS MINING YAOURE SA",
  //     date: "05 May 2023",
  //     delay: "5 jours",
  //   },
  //   {
  //     id: 13,
  //     title: "Maintenance corrective",
  //     desc: " Maintenance corrective du circuit du Transformateur de terre et entretien des Cellules Transformateurs du Power Station-Perseus Mining Yaouré",
  //     img: "assets/images/portfolio/portfolio-5.png",
  //     type: 5,
  //     gallery: [
  //       {
  //         id: 1,
  //         img: "assets/images/portfolio/portfolio-1.png",
  //       },
  //       {
  //         id: 2,
  //         img: "assets/images/portfolio/portfolio-2.png",
  //       },
  //       {
  //         id: 3,
  //         img: "assets/images/portfolio/portfolio-3.png",
  //       },
  //     ],
  //     client: "Perseus Mining Yaouré",
  //     date: "05 May 2023",
  //     delay: "5 jours",
  //   },
  //   {
  //     id: 14,
  //     title: "Projet d’alimentation",
  //     desc: "Projet d’alimentation du Viewpoint (Site IT), ligne 11 KV en Aérosouterrain, environ 1 Km dans la mine de PERSEUS YAOURE SA",
  //     img: "assets/images/portfolio/portfolio-5.png",
  //     type: 5,
  //     gallery: [
  //       {
  //         id: 1,
  //         img: "assets/images/portfolio/portfolio-1.png",
  //       },
  //       {
  //         id: 2,
  //         img: "assets/images/portfolio/portfolio-2.png",
  //       },
  //       {
  //         id: 3,
  //         img: "assets/images/portfolio/portfolio-3.png",
  //       },
  //     ],
  //     client: "PERSEUS YAOURE SA",
  //     date: "05 May 2023",
  //     delay: "1 mois",
  //   },
  //   {
  //     id: 15,
  //     title: " Projet Underground",
  //     desc: "Installation d’une ligne Aéro-souterraine de 11 KV de 2 Km au compte de PERSEUS MINING YAOURE SA",
  //     img: "assets/images/portfolio/portfolio-5.png",
  //     type: 5,
  //     gallery: [
  //       {
  //         id: 1,
  //         img: "assets/images/portfolio/portfolio-1.png",
  //       },
  //       {
  //         id: 2,
  //         img: "assets/images/portfolio/portfolio-2.png",
  //       },
  //       {
  //         id: 3,
  //         img: "assets/images/portfolio/portfolio-3.png",
  //       },
  //     ],
  //     client: "PERSEUS MINING YAOURE SA",
  //     date: "05 May 2023",
  //     delay: "1 mois",
  //   },
  //   {
  //     id: 16,
  //     title: "Projet d’installation électrique",
  //     desc: "Projet d’installation électrique du PIT et ROM PAD de PERSEUS MINING YAOURE SA (Eclairage, Pompes immergées) ",
  //     img: "assets/images/portfolio/portfolio-5.png",
  //     type: 5,
  //     gallery: [
  //       {
  //         id: 1,
  //         img: "assets/images/portfolio/portfolio-1.png",
  //       },
  //       {
  //         id: 2,
  //         img: "assets/images/portfolio/portfolio-2.png",
  //       },
  //       {
  //         id: 3,
  //         img: "assets/images/portfolio/portfolio-3.png",
  //       },
  //     ],
  //     client: "PERSEUS MINING YAOURE SA",
  //     date: "05 May 2023",
  //     delay: "2 mois",
  //   },
  // ],

  items: [
    {
      id: 1,
      title: "Fourniture et raccordement",
      desc: "Projet Banque Mondiale-Ministère de la santé de Cote d’Ivoire: Fourniture et raccordement de deux (02) Groupes Electrogènes de 160 KVA, 02 Régulateurs de tension de 180 KVA et 250 KVA et installation des unites de production d’oxygiène aux CHR d’Aboisso et Korogho au compte de SICOS Sarl  ",
      img: "assets/images/portfolio/Fourniture-et-raccordement/portfolio-1.jpeg",
      type: 4,
      gallery: [
        {
          id: 1,
          img: "assets/images/portfolio/Fourniture-et-raccordement/portfolio-2.jpg",
        },
      ],
      client: "SICOS Sarl",
      date: "05 Avril 2023",
      delay: "5 mois",
    },

    {
      id: 2,
      title: "Revision Générale",
      desc: " Revision Générale du Transformateur 630 KVA de marque NEXANS pour MONDI Abidjan SA ",
      img: "assets/images/portfolio/Revision-Générale/portfolio-2.png",
      type: 4,
      gallery: [
        {
          id: 1,
          img: "assets/images/portfolio/Revision-Générale/portfolio-1.png",
        },
        {
          id: 2,
          img: "assets/images/portfolio/Revision-Générale/portfolio-3.png",
        },
      ],
      client: "MONDI Abidjan SA",
      date: "20 Juin 2024",
      delay: "7 jours",
    },

    {
      id: 3,
      title: "Fourniture d’un coffret automatique",
      desc: "Fourniture d’un coffret automatique, Bonbonne à vessie, cable électrique 200 m pour installation d’une pompe de forage à Perseus Mining Yaouré",
      img: "assets/images/portfolio/Fourniture-d-un-coffret-automatique/portfolio-2.png",
      type: 1,
      gallery: [
        {
          id: 1,
          img: "assets/images/portfolio/Fourniture-d-un-coffret-automatique/portfolio-1.png",
        },
        {
          id: 2,
          img: "assets/images/portfolio/Fourniture-d-un-coffret-automatique/portfolio-3.png",
        },
      ],
      client: "Perseus Mining Yaouré",
      date: "10 Mars 2025",
      delay: "3 mois",
    },
  ],
};
